import { postSave } from "./savedAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  loading: false,
  error: "",
  isSaved: null,
};

export const savePost = createAsyncThunk(
  "save/patchIsSaved",
  async ({ id, isSaved }) => {
    const saved = await postSave({ id, isSaved });
    return saved;
  }
);

const savedReducer = createSlice({
  name: "save",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(savePost.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(savePost.fulfilled, (state, action) => {
        state.loading = false;
        state.isSaved = action.payload;
      })
      .addCase(savePost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
        state.isSaved = 0;
      });
  },
});

export default savedReducer.reducer;
